import { Box, Chip } from "@mui/material";

export enum UserChipType {
  Primary = "primary",
  Secondary = "secondary",
  Disabled = "disabled",
}

type Props = {
  type?: UserChipType;
  label: string;
  id: string;
};

const UserChip = ({ type = UserChipType.Primary, label, id }: Props) => (
  <Box
    component="span"
    display="flex"
    flexWrap="wrap"
    maxWidth="500px"
    columnGap="0.5rem"
    rowGap="4px"
  >
    <Chip
      key={id}
      component="span"
      sx={{
        "& .MuiChip-label": {
          fontWeight: 600,
          fontSize: "14px",
          color:
            type === UserChipType.Primary ? "inherit" : "rgba(0, 0, 0, 0.52)",
        },
        ...(type === UserChipType.Disabled && { opacity: 0.6 }),
        height: "24px",
      }}
      color={type === UserChipType.Primary ? "primary" : undefined}
      variant="outlined"
      label={label}
    />
  </Box>
);

export default UserChip;
